import { useMutation } from "@tanstack/react-query";
import { makeCRMApi } from "..";
import { IExportNotificationsRequest } from "../types/NotificationTypes";

export const useNotificationsExportMutation = () => {
  const crmApi = makeCRMApi();
  
  const notificationsExportMutation = useMutation({
    mutationKey: ['crm-notifications-export'],
    mutationFn: (requestData: IExportNotificationsRequest) => crmApi.exportNotifications(requestData),
  });
  
  return notificationsExportMutation;
}
